// 2026-11-04 (Keaton's report: two photorealistic founders speaking, lip-synced, inside an ad): who says an ad scene's
// words: the narrator (the voiceover), or one of the ad's characters on screen, in their voice and lip-synced. The API
// keeps only a speaker who is one of the ad's characters (core tidyAdSpeakers); the clip's price says what it adds.
import { isAdProject, videoBrief } from "./formats";
import type { AdScene, Project } from "./types";

export type SpeakerChoice = { id: string | null; label: string };

/** The narrator, then each of the ad's characters. Empty when it isn't an ad or it has no characters (no picker). */
export function speakerChoices(p: Pick<Project, "format" | "brief">): SpeakerChoice[] {
  if (!isAdProject(p)) return [];
  const cast = (videoBrief(p).characters ?? []).filter((c) => c.id && c.name);
  if (!cast.length) return [];
  return [{ id: null, label: "Narrator (voiceover)" }, ...cast.map((c) => ({ id: c.id, label: `${c.name}, on screen` }))];
}

/** The scene with its speaker set (null: the narrator). A scene that lists who is in its picture lists them too. */
export function withSpeaker(scene: AdScene, id: string | null): AdScene {
  const { speaker: _old, ...rest } = scene;
  if (!id) return rest;
  const ids = scene.characterIds ?? [];
  return { ...rest, speaker: id, ...(ids.length && !ids.includes(id) ? { characterIds: [...ids, id].slice(-6) } : {}) };
}
